import { properties } from '../properties.js';
import React, { Component } from 'react';
import Swal from 'sweetalert2';
import i18n from '../I18N/I18n.js'; 
import Web3 from 'web3';
import "../css/userCertificate.css";
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import NavBar from '../navbar.js';
import LogInNavBar from '../LogInNavBar.js';
import QRCode from "react-qr-code";
import standard_abi from '../../abis/Standard16A-abi.json';
import Footer from '../footer.js';
import ComponenteMultimedia from './ComponenteMultimedia.js';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import CountrySelect from '../CountrySelect.js';

import { imprimirQR, logout, apiSecuredRequest, apiPublicRequest, checkFileType, isUserOrWallet, _sendMultipleFilesToIPFS, cargarIdiomaPreferido} from '../functions.js';



class NftDisplay extends Component {

    async componentDidMount() {
		await cargarIdiomaPreferido(this.cambiarIdioma);
		// 1. Carga de Web3
		await this.loadBrandFields();

        const { bearerVar, certificadoId } = await this.checkIfWeb3UserOrLoginUser();
		// 2. Carga de datos de la Blockchain
		await this.loadDpp();
		// 3. Carga los nfts del usuario
	}

    cambiarIdioma = (idioma) => {
		const { i18n } = this.props;
		i18n.changeLanguage(idioma); 
		this.forceUpdate(); 
		Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
	  };

    logout = async () => {
        this.setState({userBearer: null});
        this.setState({email: null});
        logout();
    }


     async checkIfWeb3UserOrLoginUser() { 
            let params = (new URL(document.location)).searchParams;
            const certificadoId = params.get("certificadoId");
            this.setState({ certificadoId })
            const email = Cookies.get("email");
            
            const userRol = Cookies.get("rol");
            this.setState({ userRol: userRol });
            let bearerVar;
            
            const urlInfo = window.location.pathname.split("/")
           
            this.setState({ empresaMapping: urlInfo[1] })

            
           
           
            if (typeof email === "undefined") {
                this.setState({loggedUser: false});
            }else{
                this.setState({loggedUser: true});
                bearerVar = Cookies.get("id");
                this.setState({email: email});
            }
            
            
            
            this.setState({userBearer: bearerVar})
            return {bearerVar, certificadoId};
        }


    _checkIfInfoCorrect = async (nombre, apellido1, apellido2, email, id, idProducto, ownerAddress, codigoPais, codigoLetras) => {
        const idProductoNombre = this.state.campos.filter(campo => campo.orden == "IDPRODUCTO")[0]

        if (nombre != "" && apellido1 != "" && email != "" && idProducto != "" && ownerAddress != "" && id != "") {
            Swal.fire({
                icon: 'question',
                iconColor: "#66C08B",
                title: `${i18n.t('iscorrect')}`,
                showDenyButton: true,
                html: `
                               <style>
                    table {
                        width: 100%; /* Ensures the table uses the full width of the alert */
                        border-collapse: collapse; /* Neatly joins the borders */
                        background: #f8f8f8; /* Gives a subtle background color */
                        border-radius: 8px; /* Rounded corners for the table */
                        overflow: hidden; /* Ensures the border-radius clips the content */
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Soft shadow around the table */
                    }
                    th, td {
                        padding: 12px 15px; /* Ample padding for table cells */
                        border-bottom: 1px solid #ddd; /* Light line below each row */
                    }
                    th {
                        background-color: #e94981; /* Vibrant pinkish-magenta background for the header */
                        color: white; /* White text for better readability */
                        font-size: 16px; /* Slightly larger text for headings */
                    }
                    td {
                        color: #333; /* Darker text color for better readability */
                        font-size: 14px; /* Standard text size */
                    }
                    tr:last-child td {
                        border-bottom: none; /* Removes border from the last row */
                    }
                    td:first-child {
                        text-align: right; /* Aligns the labels to the right */
                        font-weight: bold; /* Makes the labels bold */
                        background-color: #f0f0f0; /* Light grey background for labels */
                    }
                    td:last-child {
                        text-align: left; /* Ensures values are aligned to the left */
                        background-color: #f7f7f7; /* Lighter grey background for values, enhancing contrast */
                    }
                </style>

            <table class="cewy-table">
            <thead>
                <tr>
                <th colspan="2">${i18n.t('userInfo')}</th>
                </tr>
            </thead>
            <tbody>
                <tr><td>${i18n.t('name')}:</td><td>${nombre}</td></tr>
                <tr><td>${i18n.t('apellido1')}:</td><td>${apellido1}</td></tr>
                <tr><td>${i18n.t('apellido2')}:</td><td>${apellido2}</td></tr>
                <tr><td>${i18n.t('email')}:</td><td>${email}</td></tr>
                <tr><td>${i18n.t('documento')}:</td><td>${id}</td></tr>
                <tr><td> ${i18n.t(this.state.campos.filter((campo) => campo.orden == "IDPRODUCTO")[0].nombreCampo)}:</td><td>${idProducto}</td></tr>
                <tr><td>${i18n.t('propietarioCarpeta')}:</td><td>${ownerAddress}</td></tr>
                 <tr><td>${i18n.t('country')}:</td><td>${codigoLetras}</td></tr>
            </tbody>
            </table>
                        `,
                confirmButtonText: `${i18n.t('generatePrimaryKey')}`,
                denyButtonText: `${i18n.t('makeChanges')}`,
                confirmButtonColor: "#E94981",
                // denyButtonColor: "#F07577",
                width: '750px',
            })
                .then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {

                        this._createUserIfNotExists(nombre, apellido1, apellido2, email, id, ownerAddress, idProducto, this.state.isChecked, codigoPais)


                    } else if (result.isDenied) {
                        Swal.fire({
                            title: `${i18n.t('changesNotSaved')}`,
                            confirmButtonText: `${i18n.t('Continue')}`,
                            confirmButtonColor: '#E94981',
                            icon: 'info',
                            iconColor: '#66C08B',
                            width: '560px',
                        })
                    }
                })
        } else {
            Swal.fire({
                title: `${i18n.t('missingFields')}`,
                text: '',
                icon: 'error',
                confirmButtonText: 'Back',
                confirmButtonColor: "#E94981",
            })
        }

    }

    async loadBrandFields() {
        let data = JSON.stringify({
            "email": `${properties.appUser}`,
            "password": `${properties.appPass}`
        });


        const bearerToken = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/usuario/login`, data);

        let urlParams = (new URL(document.location)).searchParams;
        const certificadoId = urlParams.get("certificadoId")
        this.setState({certificadoId});
        let camposData = JSON.stringify({
            "certificadoId": `${certificadoId}`,
            "tipoStandard": `16CAMPOS`
        });
        const certificadoCompleto = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/empresas/certificado/${certificadoId}`, "", bearerToken.data.accessToken);
        this.setState({certificadoCompleto: certificadoCompleto.data});

       

        const campos = await await apiSecuredRequest(
            'post', 
            `${properties.apiUrl}/certificat/api/campo/getCampos`, 
            camposData, 
            bearerToken.data.accessToken
        );


        
        

        this.setState({ campos: campos.data })
    }

     _getproofUWallet = async () => {
            var walletAddressInput = document.getElementById("walletAddress")
    
            if (walletAddressInput.value != "") {
                await this.setState({ isChecked: "false" })
                var corporativeWalletCheckBox = document.getElementById("corporativeWalletCheckBox")
                corporativeWalletCheckBox.checked = false
    
            } else {
                await this.setState({ isChecked: "true" })
            }
    
            var walletAddressInput = document.getElementById("walletAddress")
            if (this.state.isChecked == "true") {
                walletAddressInput.value = properties.proofUHostWallet;
    
            } else {
                document.getElementById("walletAddress")
                walletAddressInput.value = "";
            }
        }
    

     _logIn = async (nombre, password) => {
        let data = JSON.stringify({
          email: nombre,
          password: password,
        });
    
       
          const bearerToken = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/empresas/login`, data);
    
          if (bearerToken.status === 200) {
            this.setState({loginForm: false})
            this.setState({primaryKeyForm: true})
            this.state.userBearer = bearerToken.data.accessToken;
    
           
          } else {
            this.setState({userName: ""});
            this.setState({userPassword: ""});
            this.setState({loginForm: false})
            this.setState({primaryKeyForm: false})
            Swal.fire({
                title: `${i18n.t('incorrectUser')}`,
                confirmButtonText: `${i18n.t('continue')}`,
                confirmButtonColor: '#E94981',
                icon: 'error',
                iconColor: '#66C08B',
                width: '560px',
            });
          }
     }
    

    async changePestania (pestania) {
		this.setState({ pestaniaSeleccionada: pestania });
	}

    async addLoginForm(){

        if(this.state.loggedUser == true){
            this.setState({loginForm : false});
            this.setState({primaryKeyForm: true})
        }else{
            this.setState({loginForm : true});
        }

        this.setState({loginForm : true});

    }

    async loadDpp() {
        let params = (new URL(document.location)).searchParams;
        const certificadoId = params.get("certificadoId");
        const idProducto = params.get("idProducto")
        this.setState({ idProducto })
        this.setState({saleDate: new Date()});
       
        
        let data = JSON.stringify({
            "idProducto": idProducto,
            "certificadoId": certificadoId,
          });
        const selecttedNftDb = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/S16Request/getDpp`, data);
        const selecttedNft = selecttedNftDb.data;
        let tipoArchivo1 = await checkFileType(selecttedNft.tokenUri);
        this.setState({ tipoArchivo1 });

        let tipoArchivo2 = selecttedNft.tokenUri2 !== "" ? await checkFileType(selecttedNft.tokenUri2) : "";
        this.setState({ tipoArchivo2 });

        let tipoArchivo3 = selecttedNft.tokenUri3 !== "" ? await checkFileType(selecttedNft.tokenUri3) : "";
        this.setState({ tipoArchivo3 });
        let warrantyDate;
          if(selecttedNft.campo0 == ""){
            warrantyDate = new Date();
            
          }else{
            const dateString = selecttedNft?.campo0;

            // Verificar si dateString es válida
            if (!dateString) {
                warrantyDate = '';
            } else {
                // Extraer la fecha y la hora
                const [datePart, timePart] = dateString.split(", ") || [];
            
                // Extraer día, mes y año
                const [day, month, year] = (datePart || '').split("/") || [];
            
                // Construir la fecha en formato compatible con `new Date()`
                const formattedDateString = `${year || '0000'}-${String(month || '01').padStart(2, "0")}-${String(day || '01').padStart(2, "0")}T${timePart || '00:00:00'}`;
            
                warrantyDate = new Date(formattedDateString);
            }
           
          }
          this.setState({warrantyDate});
          
       

        const nftSeleccionadoVar = {
            id: selecttedNft.id ?? "",
            idProducto: selecttedNft.idProducto ?? "",
            modelo: selecttedNft.modelo ?? "",
            descripcion: selecttedNft.descripcion ?? "",
            campoA1: selecttedNft.campoA1 ?? "",
            userAddress: selecttedNft.ownerAddress ?? "",
            campoFecha: selecttedNft.campoFecha ?? "",
            tokenUri: selecttedNft.tokenUri ?? "",
            tokenUri2: selecttedNft.tokenUri2 ?? "",
            tokenUri3: selecttedNft.tokenUri3 ?? "",
            campo6: selecttedNft.campo6 ?? "",
            campo0: warrantyDate.toLocaleString()  ?? "",
            campo1: selecttedNft.campo1 ?? "",
            campo2: selecttedNft.campo2 ?? "",
            campo3: selecttedNft.campo3 ?? "",
            campo4: selecttedNft.campo4 ?? "",
            campo5: selecttedNft.campo5 ?? "",
            campo7: selecttedNft.campo7 ?? "",
            campo8: selecttedNft.campo8 ?? "",
            campo9: selecttedNft.campo9 ?? "",
            campo10: selecttedNft.campo10 ?? "",
            campo11: selecttedNft.campo11 ?? "",
            campo12: selecttedNft.campo12 ?? "",
            campo13: selecttedNft.campo13 ?? "",
            campo14: selecttedNft.campo14 ?? "",
            campo15: selecttedNft.campo15 ?? ""
        };
        this.setState({nftSeleccionado: nftSeleccionadoVar});
    
    }

    handleCountryChange = async (newCountry) => {
        const nuevoCodigoPais = event.target.value;
        this.setState({ selectedCountry: newCountry });
     

        try {
            let response;
            if(nuevoCodigoPais == "" || newCountry != nuevoCodigoPais){
                response = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/usuario/getLanguajesByCodigoPais/${newCountry}`, "", this.state.userBearer);
                this.setState({codigoPais: newCountry });
                
            }else {
                response = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/usuario/getLanguajesByCodigoPais/${nuevoCodigoPais}`, "", this.state.userBearer);
                 this.setState({codigoPais: newCountry });
            }
            
            if (response.data && response.data.length > 1) {
                this.setState({multiLanguajeCountry: "true"});
                this.setState({idiomasDisponibles: response.data})
                console.log("Más de un idioma recibido:", response.data);
            } else if (response.data.length == 1) {
                this.setState({multiLanguajeCountry: "false"});
                
            } else {
                console.log("No se recibieron idiomas.");
            }
        } catch (error) {
            // Manejar errores aquí
            console.error("Error al obtener los idiomas:", error);
            Swal.fire({
                title: `${i18n.t('errorOccurred')}`,
                confirmButtonText: `${i18n.t('continue')}`,
                confirmButtonColor: '#E94981',
                icon: 'error',
                iconColor: '#66C08B',
                width: '560px',
            });
        }
    };

    _encryptUserInfoAndSaveCertificate = async (nombre, apellido1, apellido2, documento, email, idProducto, ownerAddress) => {
        
        this.setState({userEmail: email});


        try {
            const web3 = new Web3(new Web3.providers.HttpProvider(properties.web3Provider));
            const abi = standard_abi;
            const direccion = this.state.certificadoCompleto.direccion;
            if(abi && direccion){
                const contract = new web3.eth.Contract(abi, direccion);
                this.setState({ contract })
                const userInfo = await contract.methods.createUserInfo(nombre, apellido1, apellido2, email, documento, 
                    idProducto,
                    ownerAddress).call({ from: properties.proofUHostWallet})
                
                this.setState({ userInfo })
                this.setState({ idProducto })
                this.setState({ ownerAddress })
                
                const nftSeleccionado = this.state.nftSeleccionado || {};
                const usuario = JSON.parse(localStorage.getItem('usuarioCertificado'));

                let data = JSON.stringify({
                    "userInfo": userInfo, // 32 bytes en hexadecimal
                    "userId": usuario.id,
                    "campo1A": nftSeleccionado.campoA1 ?? "",  // uint256 valor numérico
                    "modelo": nftSeleccionado.modelo ?? "",  // string
                    "descripcion": nftSeleccionado.descripcion ?? "",  // string
                    "idProducto": nftSeleccionado.idProducto ?? "",  // string, identificador del producto
                    "userAddress": ownerAddress ?? "",  // address en formato Ethereum
                    "campoFecha": this.state.saleDate ?? "",  // string, campo fecha
                    "campo0": this.state.warrattyDate ?? "",
                    "campo1": nftSeleccionado.campo1 ?? "",
                    "campo2": nftSeleccionado.campo2 ?? "",
                    "campo3": nftSeleccionado.campo3 ?? "",
                    "campo4": nftSeleccionado.campo4 ?? "",
                    "campo5": nftSeleccionado.campo5 ?? "",
                    "campo6": nftSeleccionado.campo6 ?? "",
                    "campo7": nftSeleccionado.campo7 ?? "",
                    "campo8": nftSeleccionado.campo8 ?? "",
                    "campo9": nftSeleccionado.campo9 ?? "",
                    "campo10": nftSeleccionado.campo10 ?? "",
                    "campo11": nftSeleccionado.campo11 ?? "",
                    "campo12": nftSeleccionado.campo12 ?? "",
                    "campo13": nftSeleccionado.campo13 ?? "",
                    "campo14": nftSeleccionado.campo14 ?? "",
                    "campo15": nftSeleccionado.campo15 ?? "",
                    "imageURI": nftSeleccionado.tokenUri ?? "",  
                    "imageURI2": nftSeleccionado.tokenUri2 ?? "",
                    "imageURI3": nftSeleccionado.tokenUri3 ?? "",
                    "certificadoId": this.state.certificadoId ?? "" // ID de la empresa para obtener datos asociados
                });
                  const response = apiSecuredRequest("post", `${properties.apiUrl}/certificat/api/web3jService/createStandard16Data`, data, this.state.userBearer);
                  
                  Swal.fire({
                    title: 'OK',
                    text: `${i18n.t('receiveEmail')}`,
                    imageUrl: `${this.state.imageURI}`,
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Go to admin tool'
                }).then((result) => {
                    if (result.isConfirmed) {
                       
                    }
                    if(result.dismiss){
                        
                    }
                })
                this._generateQRCertificate();
            
                }
           
           

        } catch (err) {
            this.setState({ errorMessage: err })
            this.setState({ userName: ''})
            this.setState({ userPassword: ''}) ;
            this.setState({ codigoPais: 'ESP'}) ;
            Swal.fire({
                title: `${i18n.t('errorOccurred')}`,
                confirmButtonText: `${i18n.t('continue')}`,
                confirmButtonColor: '#E94981',
                icon: 'info',
                iconColor: '#66C08B',
                width: '560px',
            })

        } 
    }

     _generateQRCertificate = async()  => {
          const usuario = JSON.parse(localStorage.getItem('usuarioCertificado'));
          
          // QR for quick validation generation
          const QRValidationUrl = `${properties.clientApp}/${this.state.empresaMapping}/standard16/QRValidation?nombre=${usuario.nombre}` +
            `&apellido1=${usuario.apellido1}&apellido2=${usuario.apellido2}&email=${usuario.email}` +
            `&idProducto=${this.state.idProducto}&account=${usuario.walletDir}` +
            `&documento=${usuario.documento}&certificadoId=${this.state.certificadoId}`;
          this.setState({ QRcode: QRValidationUrl })
          this.setState({ showQRcode: true });
          localStorage.removeItem('usuarioCertificado');
        }

        _showQrCode = async() => {
            
            
            // QR for quick validation generation
            const DppQR = `${properties.adminApp}/${this.state.empresaMapping}/standard16DPP?idProducto=${this.state.idProducto}&certificadoId=${this.state.certificadoId}`;
            this.setState({ QRcode: DppQR })
            this.setState({ showQRcode: true });
        }


    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
      };

      

      _createUserIfNotExists = async (nombre, apellido1, apellido2, email, documento, ownerAddress, idProducto, isChecked, codigoPais) => {
        Cookies.remove('usuario');
        let emailWrapper = JSON.stringify({
            "email": email, 
            "documento": documento,
        });
        let userExistsResponse;

            try {
                userExistsResponse = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/getUserByMailOrDocument`, emailWrapper, this.state.userBearer);
                localStorage.setItem('usuarioCertificado', JSON.stringify(userExistsResponse.data));     
            } catch (error) {
                console.error("Error al verificar la existencia del usuario:", error);

                Swal.fire({
                    title: `${i18n.t('errorOccurred')}`,
                    confirmButtonText: `${i18n.t('continue')}`,
                    confirmButtonColor: '#E94981',
                    icon: 'error',
                    iconColor: '#66C08B',
                    width: '560px',
                });

                userExistsResponse = {}; // En caso de error, se asigna un objeto vacío
            }
        
        if (userExistsResponse.status == 200 && userExistsResponse.data.length == 0 ) {
            let isActive = (isChecked == "true") ? false : true
            let data = JSON.stringify({
                "email": email,
                "activeUser": isActive,
                "nombre": nombre,
                "apellido1": apellido1,
                "apellido2": apellido2,
                "termsAndConditions": false,
                "documento": documento,
                "walletDir": ownerAddress,
                "proofUWallet": isChecked,
                "codigoPais": codigoPais,
                "userRol": {
                    "id": "2",
                    "rol": "USER"
                }
            });
    
            const userResponse = apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/guardar`, data, this.state.userBearer) .then(userExistsResponse => {
                localStorage.setItem('usuarioCertificado', JSON.stringify(userResponse.data));
                Swal.fire(`${i18n.t('newUser')}`, '', 'success')
              })
              .catch(error => {
                console.error('Error al guardar el usuario:', error);
                Swal.fire({
                    title: `${i18n.t('userNotSaved')}`,
                    confirmButtonText: `${i18n.t('Continue')}`,
                    confirmButtonColor: '#E94981',
                    icon: 'info',
                    iconColor: '#66C08B',
                    width: '560px',
                })
              });
            this._encryptUserInfoAndSaveCertificate(nombre, apellido1, apellido2, documento, email, idProducto, document.getElementById("walletAddress").value)
        }else{
            userExistsResponse.data.codigoPais
            this.setState({userId: userExistsResponse.data.id})
            const codigoLetras = userExistsResponse.data.codigoPais.replace(/\d{0,3}$/, '');
            this.setState({codigoPais: codigoLetras});
            Swal.fire({
                icon: 'info',
                iconColor: "#66C08B",
                title: `${i18n.t('emailAlreadyRegistered')}<br>${i18n.t('continueWithThisUser')}`,
                showDenyButton: true,
                html: `   <style>
                    table {
                        width: 100%; /* Ensures the table uses the full width of the alert */
                        border-collapse: collapse; /* Neatly joins the borders */
                        background: #f8f8f8; /* Gives a subtle background color */
                        border-radius: 8px; /* Rounded corners for the table */
                        overflow: hidden; /* Ensures the border-radius clips the content */
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Soft shadow around the table */
                    }
                    th, td {
                        padding: 12px 15px; /* Ample padding for table cells */
                        border-bottom: 1px solid #ddd; /* Light line below each row */
                    }
                    th {
                        background-color: #e94981; /* Vibrant pinkish-magenta background for the header */
                        color: white; /* White text for better readability */
                        font-size: 16px; /* Slightly larger text for headings */
                    }
                    td {
                        color: #333; /* Darker text color for better readability */
                        font-size: 14px; /* Standard text size */
                    }
                    tr:last-child td {
                        border-bottom: none; /* Removes border from the last row */
                    }
                    td:first-child {
                        text-align: right; /* Aligns the labels to the right */
                        font-weight: bold; /* Makes the labels bold */
                        background-color: #f0f0f0; /* Light grey background for labels */
                    }
                    td:last-child {
                        text-align: left; /* Ensures values are aligned to the left */
                        background-color: #f7f7f7; /* Lighter grey background for values, enhancing contrast */
                    }
                </style>


                <table class="cewy-table">
                    <thead>
                        <tr>
                            <th colspan="2">${i18n.t('Customer Information')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td>${i18n.t('name')}:</td><td>${userExistsResponse.data.nombre}</td></tr>
                        <tr><td>${i18n.t('apellido1')}:</td><td>${userExistsResponse.data.apellido1}</td></tr>
                        <tr><td>${i18n.t('apellido2')}:</td><td>${userExistsResponse.data.apellido2}</td></tr>
                        <tr><td>${i18n.t('email')}:</td><td>${userExistsResponse.data.email}</td></tr>
                        <tr><td>${i18n.t('documento')}:</td><td>${userExistsResponse.data.documento}</td></tr>
                        <tr><td>${i18n.t('propietarioCarpeta')}:</td><td>${userExistsResponse.data.walletDir}</td></tr>
                          <tr><td>${i18n.t('country')}:</td><td>${codigoLetras}</td></tr>
                    </tbody>
                    </table>`,
                                confirmButtonText: `${i18n.t('continue')}`,
                                confirmButtonColor: "#E94981",
                                denyButtonColor: "#d33",
                                denyButtonText: `${i18n.t('changeUser')}`,
                                width: 600,
                                padding: "3em",
                                // color: "#716add",
                                background: "#fff url(/images/trees.png)"
                            }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                    if (nombre != userExistsResponse.data.nombre) {
                                        document.getElementById('nombreInput').value = userExistsResponse.data.nombre;
                                        nombre = userExistsResponse.data.nombre;
                                    }
                                    
                                    // Verificar si el primer apellido es diferente y actualizar el input si es necesario
                                    if (apellido1 != userExistsResponse.data.apellido1) {
                                        document.getElementById('apellido1Input').value = userExistsResponse.data.apellido1;
                                        apellido1 = userExistsResponse.data.apellido1;
                                    }
                                    
                                    // Verificar si el segundo apellido es diferente y actualizar el input si es necesario
                                    if (apellido2 != userExistsResponse.data.apellido2) {
                                        document.getElementById('apellido2Input').value = userExistsResponse.data.apellido2;
                                        apellido2 = userExistsResponse.data.apellido2;
                                    }
                                    
                                    // Verificar si el documento es diferente y actualizar el input si es necesario
                                    if (documento != userExistsResponse.data.documento) {
                                        document.getElementById('documentoInput').value = userExistsResponse.data.documento;
                                        documento = userExistsResponse.data.documento;
                                    }
                                    if (userExistsResponse.data.proofUWallet != isChecked) {
                                        var checkBoxValue = userExistsResponse.data.proofUWallet
                                        if (checkBoxValue == "true") {
                                            document.getElementById("corporativeWalletCheckBox").checked = true
                                            this.setState({ isChecked: "true" })

                                        } else {
                                            document.getElementById("corporativeWalletCheckBox").checked = false
                                            this.setState({ isChecked: "false" })

                                        }
                                        if (document.getElementById("corporativeWalletCheckBox").checked == true) {
                                            this.setState({ ownerAddress: properties.proofUHostWallet })
                                            var walletAddressInput = document.getElementById("walletAddress")
                                            walletAddressInput.value = properties.proofUHostWallet;

                                        } else {
                                            this.setState({ ownerAddress: userExistsResponse.data.walletDir })
                                            var walletAddressInput = document.getElementById("walletAddress")
                                            walletAddressInput.value = userExistsResponse.data.walletDir;
                                        }
                                    }
                                    localStorage.setItem('usuarioCertificado', JSON.stringify(userExistsResponse.data));
                                    this._encryptUserInfoAndSaveCertificate(nombre, apellido1, apellido2, documento, email, idProducto, document.getElementById("walletAddress").value)
                                    
                                }
                                else if (result.isDenied) {
                                    Swal.fire({
                                        title: `${i18n.t('changesNotSaved')}`,
                                        confirmButtonText: 'Continue',
                                        confirmButtonColor: '#E94981',
                                        icon: 'info',
                                        iconColor: '#66C08B',
                                        width: '560px',
                                    })
                                }
                            })

                        }
        

    }

    constructor(props) {
		super(props)
		this.state = {
			idProducto: null,
			nftSeleccionado: null,
            email: null,
			tipoArchivo1: null,
			tipoArchivo2: null,
			tipoArchivo3: null,
			userId: null,
			userBearer: null,
			campos: null,
			certificadoId: null,
            certificadoCompleto: null,
			empresaMapping: null,
            userRol: null,
            pestaniaSeleccionada: 1,
            loginForm: false,
            primaryKeyForm: false,
            userName: null,
            userPassword: null,
            selectedCountry: null,
            multiLanguajeCountry: "false",
            selectedCountry: null,
            codigoPais: "ESP",
            isChecked: null,
            contract: null,
            QRcode: null,
            showQRcode: false,
            saleDate: null,
            warrantyDate: null,
            loggedUser: null
		};
        this.changePestania = this.changePestania.bind(this)
		
	}


    render(){

        

        if (this.state.nftSeleccionado != null && this.state.campos != null) {

            const fechaA1 = new Date(this.state.nftSeleccionado.campoA1);
            const fecha0 = new Date(this.state.nftSeleccionado.campo0);
            const fechaFormateada = isNaN(fecha0.getTime()) ? "" : fecha0;
            const empresa = this.state.certificadoCompleto.empresa;
            const camposOpcionales = this.state.campos
            .filter(campo => {
                const match = campo.orden.match(/^CAMPO(\d{1,2})$/);
                return match && parseInt(match[1]) >= 0 && parseInt(match[1]) <= 15;
            });

            return (
                <>
                    {this.state.loggedUser == true ?   <NavBar mail={this.state.email} bearer={this.state.userBearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />  : 
                 <LogInNavBar cambiarIdioma={this.cambiarIdioma}/>
                }
        
                   
                    <ComponenteMultimedia
										tipoArchivo1={this.state.tipoArchivo1}
										tipoArchivo2={this.state.tipoArchivo2}
										tipoArchivo3={this.state.tipoArchivo3}
										pestaniaSeleccionada = {this.state.pestaniaSeleccionada}
										changePestania = {this.changePestania}
									/>     


                   
     
                   
                   <div className="content_info_16">
                 
                   {this.state.showQRcode != false && (
                         <div className="modal-overlay">
                  <div className="modal-content form">
                      <button className="modal-close" onClick={() => this.setState({ showQRcode: false })}>
                          {i18n.t('close')}
                      </button>

                      <div className="cewy-qrcode-container">
                          <QRCode value={this.state.QRcode} />

                          <button className="cewy-qrcode-button" onClick={() => imprimirQR(this.state.QRcode)}>
                              {i18n.t('imprimirQR')}
                          </button>
                      </div>
                  </div>
                        
                        </div>
                      
                        
                      )}
                       <div>
                    <h1 className="enterprise_data">{empresa.name}</h1>
                    <h1 className="enterprise_web">{empresa.url}</h1>
                    <h1 className="enterprise_web">{empresa.telefonoContacto}</h1>
                    </div>
                     
                   <p className="product_model_16">{this.state.nftSeleccionado.modelo}</p>
                   <div className="certificateProductData_card_1">
                                           <p className="titleCard_16">{i18n.t('ProductDetails')}</p>
                                           
                                           <table className="productDetails_table_16">
                                                <tbody>
                                                {this.state.campos.some(campo => campo.orden === "IDPRODUCTO") && (
                                                        <tr>
                                                            <th className="details_th_16">
                                                                {i18n.t(this.state.campos.find(campo => campo.orden === "IDPRODUCTO").nombreCampo)}
                                                            </th>
                                                            <td className="details_td_16">{this.state.nftSeleccionado.idProducto}</td>
                                                        </tr>
                                                    )}

                                                    {this.state.campos.some(campo => campo.orden === "CAMPO1A") && (
                                                        <tr>
                                                            <th className="details_th_16">
                                                                {i18n.t(this.state.campos.find(campo => campo.orden === "CAMPO1A").nombreCampo)}
                                                            </th>
                                                            <td className="details_td_16">{fechaA1.toLocaleString()}</td>
                                                        </tr>
                                                    )}

                                                    

                                                    {camposOpcionales.some(campo => campo.orden === "CAMPO0" && campo.mostrar === "true") && (
                                                        <tr key="campo0">
                                                            <th className="details_th_16">{i18n.t(camposOpcionales.find(campo => campo.orden === "CAMPO0").nombreCampo)}</th>
                                                            <td className="details_td_16">{fechaFormateada.toLocaleString()}</td>
                                                        </tr>
                                                    )}

                                                    {camposOpcionales.map((campo) => {
                                                        const index = campo.orden.slice(5); // Extrae el número del orden
                                                        if (campo.orden === "CAMPO0") return null; // Evita duplicar campo0

                                                        return campo.mostrar === "true" && (
                                                            <tr key={`campo${index}`}>
                                                                <th className="details_th_16">{i18n.t(campo.nombreCampo)}</th>
                                                                <td className="details_td_16">{this.state.nftSeleccionado[`campo${index}`]}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                           
                                       </div>
                   
                                       <button type="submit" className="cewy_homePage_emailBtn2" onClick={(event) => { this.addLoginForm() }}>
									            {i18n.t('addUser')}
									        </button>
                                            <button
                                        type="button"
                                        className="cewy_homePage_emailBtn"
                                        onClick={this._showQrCode}
                                        >
                                            {i18n.t('showQR')}
                                        </button>

                                      
                   </div>
                    <Footer /> 

                    {this.state.loginForm && (<>
                        <div className="modal-overlay2">
                        <div className="modal-content">
                        <div className="form-column">
          {/* <h2 className>Login</h2> */}

        
            <input
              type="text"
              name="userName"
              value={this.state.userName}
              onChange={this.handleInputChange}
              placeholder="Email"
              className="custom-input-field"
              ref={(email) => (this.email = email)}
              required
            />

            <input
              type="password"
              name="userPassword"
              value={this.state.userPassword}
              onChange={this.handleInputChange}
              placeholder="Password"
              className="custom-input-field"
              ref={(pass) => (this.pass = pass)}
              required
            />

            <div className="custom-button-container">
              <button type="submit" className="custom-btn" onClick={() => {
                const email = this.state.userName.trim(); 
                const pass = this.state.userPassword.trim();
                if (email && pass) {
                  this._logIn(email, pass);
                } else {

                    Swal.fire({
                        title: `${i18n.t('missingFields')}`,
                        confirmButtonText: `${i18n.t('continue')}`,
                        confirmButtonColor: '#E94981',
                        icon: 'error',
                        iconColor: '#66C08B',
                        width: '560px',
                    });
                }
                }}>
                Log In
              </button>

              <button
                type="button"
                className="custom-btn"
                onClick={() => {
                  this.setState({loginForm: false})
                }}
              >
                {i18n.t('back')}
              </button>
            </div>

          
        </div>
        </div>
        </div>
                    
                    
                    
                    </>)}


            {this.state.primaryKeyForm && (<>
                        <div className="cewy-modal-overlay">
                        <div className="cewy-modal-content ">
                        <div className="cewy-modal-body">
          {/* <h2 className>Login</h2> */}

          
            <div className="cewy-column2">
            <label className="cewy-input-label">{i18n.t('country')}</label>
            <CountrySelect
                    value={this.state.codigoPais}
                    onChange={this.handleCountryChange} usuarioRelleno = {this.state.usuarioRelleno}
                  />
            {this.state.multiLanguajeCountry == "true" && (
                                    <>
                                    <label className="cewy-label">
                                    {i18n.t('idioma')}
                                    </label>
                                    {this.state.codigoNumero == null ? (
                                            <select
                                                className="cewy-input"
                                                ref={(codigoIdioma) => (this.codigoIdioma = codigoIdioma)}
                                                disabled={this.state.usuarioRelleno != null} // Condición para deshabilitar
                                            >
                                                {this.state.idiomasDisponibles.map((idioma, index) => (
                                                <option key={idioma.id} value={idioma.id}>
                                                    {i18n.t(idioma.idioma)}
                                                </option>
                                                ))}
                                            </select>
                                            ) : (
                                            <select
                                                className="cewy-input"
                                                value={this.state.codigoNumero}
                                                ref={(codigoIdioma) => (this.codigoIdioma = codigoIdioma)}
                                                disabled={this.state.usuarioRelleno !== null} // Condición para deshabilitar
                                            >
                                                {this.state.idiomasDisponibles.map((idioma) => (
                                                <option key={idioma.id} value={idioma.id}>
                                                    {i18n.t(idioma.idioma)}
                                                </option>
                                                ))}
                                            </select>
                                            )}

                                    </>
                                )}
                <label className="cewy-input-label">{i18n.t('name')}</label>
                {this.state.usuarioRelleno == null ? <input type="text" id="nombreInput" className="cewy-input" ref={(nombre) => this.nombre = nombre} /> : 
                <input type="text" id="nombreInput" className="cewy-input" value={this.state.usuarioRelleno.nombre} ref={(nombre) => this.nombre = nombre} />}
                

                <label className="cewy-input-label">{i18n.t('apellido1')}</label>

                {this.state.usuarioRelleno == null ? <input type="text" id="apellido1Input" className="cewy-input" ref={(apellido1) => this.apellido1 = apellido1} /> : 
                <input type="text" id="apellido1Input" className="cewy-input" value={this.state.usuarioRelleno.apellido1} ref={(apellido1) => this.apellido1 = apellido1} />}
              
                <label className="cewy-input-label">{i18n.t('apellido2')}</label>
                {this.state.usuarioRelleno == null ? <input type="text" id="apellido2Input" className="cewy-input" ref={(apellido2) => this.apellido2 = apellido2} />  : 
                <input type="text" id="apellido2Input" className="cewy-input" value={this.state.usuarioRelleno.apellido2} ref={(apellido2) => this.apellido2 = apellido2} />}
                
                    

                
            </div>

            <div className="cewy-column2">
                <label className="cewy-input-label">{i18n.t('email')}</label>
                {this.state.usuarioRelleno == null ?  <input type="text" id="emailInput" className="cewy-input" ref={(email) => this.email = email} />  : 
                 <input type="text" id="emailInput" className="cewy-input"  value={this.state.usuarioRelleno.email} ref={(email) => this.email = email} />
                }
                

               

                <label className="cewy-input-label">{i18n.t('documento')}</label>

                {this.state.usuarioRelleno == null ?   <input type="text" id="documentoInput" className="cewy-input" ref={(id) => this.id = id} /> : 
                 <input type="text" id="documentoInput" className="cewy-input" value={this.state.usuarioRelleno.documento} ref={(id) => this.id = id} />
                }

               

                <label className="cewy-input-label"> {i18n.t(this.state.campos.filter((campo) => campo.orden == "IDPRODUCTO")[0].nombreCampo)}</label>
                <input type="text"  value = {this.state.idProducto} disabled className="cewy-input" ref={(idProducto) => this.idProducto = idProducto} />
            </div>

            <label className="cewy-label">
                {i18n.t(this.state.campos.filter((campo) => campo.orden == "CAMPO0")[0].nombreCampo)}
            </label>
            <DatePicker
                dateFormat="dd/MM/yyyy, HH:mm"
                showTimeSelect
                timeFormat="HH:mm"
                selected={this.state.warrantyDate}
                onChange={(warrattyDate) => this.setState({ warrattyDate })}
                className="cewy-datepicker"
            />

            <label className="cewy-label">
                {i18n.t(this.state.campos.filter((campo) => campo.orden == "FECHA")[0].nombreCampo)}
            </label>
            <DatePicker
                dateFormat="dd/MM/yyyy, HH:mm"
                showTimeSelect
                timeFormat="HH:mm"
                selected={this.state.saleDate}
                onChange={(saleDate) => this.setState({ saleDate })}
                className="cewy-datepicker"
            />
       
      
            
           
        <div className="cewy-wallet-container2">
                <div>
        <label className="cewy-input-label">{i18n.t('proofUWallet')}</label>
        {this.state.usuarioRelleno == null ?    <input type="checkbox"
                id="corporativeWalletCheckBox"
                name="topping"
                className='cewy-checkbox'
                value="Hold on corporative wallet"
                checked={this.state.isChecked}
                onChange={this._getproofUWallet} />: 
                <input type="checkbox"
                id="corporativeWalletCheckBox"
                name="topping"
                className='cewy-checkbox'
                value="Hold on corporative wallet"
                checked={this.state.usuarioRelleno.proofUWallet}
                onChange={this._getproofUWallet} />
                }
        </div>
      

        {this.state.usuarioRelleno == null ?    <input type="text" className="cewy-inputAddress"
                placeholder={i18n.t('propietarioCarpeta')}
                id="walletAddress"
                ref={(ownerAddress) => this.ownerAddress = ownerAddress} /> : 
                <input type="text" className="cewy-inputAddress"
                placeholder={i18n.t('propietarioCarpeta')}
                id="walletAddress" value = {this.state.usuarioRelleno.walletDir}
                ref={(ownerAddress) => this.ownerAddress = ownerAddress} />
                }
        </div>


            <div className="custom-button-container">
              <button type="submit" className="custom-btn" onClick={() => {
                const nombre = this.nombre?.value.trim(); 
                const apellido1 = this.apellido1?.value.trim(); 
                const apellido2 = this.apellido2?.value.trim(); 
                const email = this.email?.value.trim(); 
                const ownerAddress = this.ownerAddress.value;
                const id = this.id?.value.trim(); 
                const idProducto = this.idProducto?.value.trim(); 
                let codigoLetras;
                let codigoPais;
                codigoLetras = this.state.codigoPais;
                if(this.state.multiLanguajeCountry == "true"){
                    codigoPais = this.state.codigoPais.concat(this.codigoIdioma.value);
                }else{
                    codigoPais = this.state.codigoPais;
                }
                this._checkIfInfoCorrect(nombre, apellido1, apellido2, email, id, idProducto, ownerAddress, codigoPais, codigoLetras);
                
                }}>
               {i18n.t('generateCertificate')}
              </button>

              <button
                type="button"
                className="custom-btn"
                onClick={() => {
                  this.setState({primaryKeyForm: false});
                  this.setState({loginForm: false});
                }}
              >
                {i18n.t('back')}
              </button>
            </div>
        </div>
        </div>
        </div>        
                    
                    </>)}
                    
                   
                </>
            );

        }

        

      

    }



}export default withTranslation()(NftDisplay);